import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import IntroSection from "@/components/IntroSection";

export default function Introduction() {
  const { t } = useLang();
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6 sm:py-10" data-testid="introduction-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-ochre hover:underline mb-4" data-testid="introduction-back"><ArrowLeft className="w-4 h-4 rtl:rotate-180" /> {t("back")}</Link>
      <IntroSection />
    </div>
  );
}
